import { RUNG_TONE, type LadderRung, type RungTone } from '@d-orca/shared/client/activities';

// The lifecycle LADDER (docs/specs/2026-09-18-task-commit-ux-design.md,
// decision 2) lives in `@d-orca/shared/client/activities` — the mobile app
// wears the same rungs. What stays here is the web's paint for them.

export { ladderOf } from '@d-orca/shared/client/activities';
export type { ILadder, ILadderActivity, LadderRung, LadderStep } from '@d-orca/shared/client/activities';

/** The CSS-module class each rung TONE paints with (`_status.module.css`).
 *  Which tone a rung wears is shared with the mobile app (`RUNG_TONE`). */
const TONE_CLASS: Record<RungTone, string> = {
  planned: 'rungPlanned',
  blocked: 'rungBlocked',
  committed: 'rungCommitted',
  progress: 'rungProgress',
  late: 'rungLate',
  areasDone: 'rungAreasDone',
  done: 'rungDone',
};

/** The class a rung colours with — its tone's. */
export function rungClass(rung: LadderRung): string {
  return TONE_CLASS[RUNG_TONE[rung]];
}
